import { render } from "./FrameJson.vue?vue&type=template&id=8b131972&scoped=true"
import script from "./FrameJson.vue?vue&type=script&lang=js"
export * from "./FrameJson.vue?vue&type=script&lang=js"

import "./FrameJson.vue?vue&type=style&index=0&id=8b131972&lang=less&scoped=true"
import "./FrameJson.vue?vue&type=style&index=1&id=8b131972&lang=less"
import "./FrameJson.vue?vue&type=style&index=2&id=8b131972&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b131972"]])

export default __exports__